// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_8vH","textarea":"styles_textarea__21Vu5"};